import { PlusOutlined } from '@ant-design/icons';
import { Col, DatePicker, Row, Table, Tag } from "antd";
import { ContentHeader } from "../../components";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Links } from "../../helpers/Links";
import { Link } from "react-router-dom";
import { menuHelper } from "../../helpers/account";;
import { DsThueNamResponse } from '../../models/thue/Thue';
import { formatVND } from '../../helpers/common';
import { layDsQuyetToanThueThuongXuyen } from '../../services/thue';

const DsQuyetToanThueThuongXuyen = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [dataTable, setDataTable] = useState<Array<DsThueNamResponse>>();
    const menu: any = menuHelper.checkMultiPermission([Links.Thue.DsQuyetToanThuongXuyen, Links.Thue.ChiTietQuyetToanThuongXuyen]);

    const layDuLieu = async () => {
        try {
            setIsLoading(true);
            var rs = await layDsQuyetToanThueThuongXuyen();
            setDataTable((rs || []).map((v: DsThueNamResponse) => { return { ...v, key: v.id } }));
            setIsLoading(false);
        }
        catch (err: any) {
            toast.error(err);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        layDuLieu();
    }, [])

    return (
        <section>
            <ContentHeader title="Quyết toán thuế TNCN" />
            <Row className="mb-2">                
                <Col span="24">
                    {
                        menu[Links.Thue.ChiTietQuyetToanThuongXuyen] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.Thue.ChiTietQuyetToanThuongXuyen}><PlusOutlined rev="" />Thêm mới</Link>
                    }
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={dataTable}
                            loading={isLoading}
                            locale={{ emptyText: "Không có dữ liệu" }}
                        >
                            <Column title="Năm" dataIndex="kyThue" key="kyThue" />
                            <Column title="Số CBCNV" dataIndex="soNhanVien" key="soNhanVien" />
                            <Column title="Tổng tiền thuế phải nộp" dataIndex="tongThuePhaiNop" key="tongThuePhaiNop" render={(text: number) => formatVND(text)} />
                            <Column title="Trạng thái" dataIndex="khoaDieuChinh" key="khoaDieuChinh" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case 0: tag = (<Tag color="success">Mở khóa</Tag>); break;
                                    case 1: tag = (<Tag color="red">Khóa điều chỉnh</Tag>); break;
                                }
                                return tag;
                            }} />
                            {
                                menu[Links.Thue.ChiTietQuyetToanThuongXuyen] &&
                                <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                    return <Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Thue.ChiTietQuyetToanThuongXuyen + "?id=" + record.id}>Xem</Link>
                                }} />
                            }
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DsQuyetToanThueThuongXuyen;